import {Component} from '@angular/core';

@Component({
  selector: 'mc-alert-icon',
  templateUrl: './alert-icon.component.html',
  styleUrls: ['./alert-icon.component.scss'],
})
export class AlertIconComponent {}
